export const SET_STRIPE_PUBLIC_KEY = 'addStripePublicKey';
